// ./venda/index.tsx (ou ./venda.tsx)
import React, { useEffect, useMemo, useState } from "react";
import TextFieldRow from "../../../../components/TextFieldRow";

type Props = {
  clienteNome: string;
  setClienteNome: (v: string) => void;

  nomeEmbarcacaoVenda: string;
  setNomeEmbarcacaoVenda: (v: string) => void;

  numeroPV: string;
  setNumeroPV: (v: string) => void;
};

const EMPRESAS_URL =
  "https://api.eva-googlemarine.com/geral/empresa-clientes-nome";

const VendaMovement: React.FC<Props> = ({
  clienteNome,
  setClienteNome,
  nomeEmbarcacaoVenda,
  setNomeEmbarcacaoVenda,
  numeroPV,
  setNumeroPV,
}) => {
  const [empresaOptions, setEmpresaOptions] = useState<string[]>([]);
  const [loadingEmpresas, setLoadingEmpresas] = useState(false);
  const [erroEmpresas, setErroEmpresas] = useState<string | null>(null);

  // Normalizador para MAIÚSCULO
  const toUpper = (fn: (v: string) => void) => (v: string) =>
    fn((v || "").toUpperCase());

  // Buscar nomes de empresas
  useEffect(() => {
    let alive = true;
    const ctrl = new AbortController();

    (async () => {
      setLoadingEmpresas(true);
      setErroEmpresas(null);
      try {
        const res = await fetch(EMPRESAS_URL, {
          method: "GET",
          headers: { Accept: "application/json" },
          signal: ctrl.signal,
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const json = await res.json();
        const list: string[] = Array.isArray(json?.data)
          ? (json.data as string[])
          : [];

        const unique = Array.from(
          new Set(
            list
              .map((s) => (typeof s === "string" ? s.trim().toUpperCase() : ""))
              .filter(Boolean)
          )
        );

        if (alive) setEmpresaOptions(unique);
      } catch (e: any) {
        if (alive) setErroEmpresas(String(e?.message || e));
      } finally {
        if (alive) setLoadingEmpresas(false);
      }
    })();

    return () => {
      alive = false;
      ctrl.abort();
    };
  }, []);

  // Dropdown options (undefined quando vazio)
  const empresaDropdown = useMemo(
    () => (empresaOptions.length ? empresaOptions : undefined),
    [empresaOptions]
  );

  return (
    <div>
      <TextFieldRow
        center={{
          label: "Nome do Cliente",
          value: clienteNome,
          onChange: toUpper(setClienteNome),
          placeholder: loadingEmpresas
            ? "CARREGANDO EMPRESAS..."
            : erroEmpresas
            ? "FALHA AO CARREGAR. DIGITE MANUALMENTE."
            : "SELECIONE O CLIENTE",
          options: empresaDropdown, // <<< dropdown de empresas
        }}
      />

      <TextFieldRow
        left={{
          label: "Nome da Embarcação",
          value: nomeEmbarcacaoVenda,
          onChange: toUpper(setNomeEmbarcacaoVenda),
          placeholder: "Digite o nome da Embarcação",
        }}
        right={{
          label: "Número da P.V",
          value: numeroPV,
          onChange: (v) => setNumeroPV((v || "").toUpperCase()),
          placeholder: "Digite o número da Proposta de Venda",
        }}
      />
    </div>
  );
};

export default VendaMovement;
